import React from 'react';

import { LanguageEnum } from '../../../../graphql/gen/types';
import { LanguageEnumData, TimeZoneEnumData } from '../../../../utils/enumData';
import { PlexSelect } from '../../../shared/primitives/PlexSelect';
import { PlexTextField } from '../../../shared/primitives/PlexTextField';
import { SettingsContent } from '../SettingsContent';
import { useAccountStyles } from './styles';
import { SettingsPageProps } from './types';

export const GeneralSettings = ({
  savedSettings,
  unsavedSettings,
  loadingMutation,
  onChange,
  onSave,
  onCancel,
  updateDisabled,
}: SettingsPageProps): React.ReactElement => {
  const classes = useAccountStyles();
  return (
    <SettingsContent
      title={'General Settings'}
      onSave={onSave}
      onCancel={onCancel}
      updateDisabled={updateDisabled}
      loadingMutation={loadingMutation}
    >
      <PlexTextField
        id={'general-settings-status'}
        label={'Default status'}
        value={unsavedSettings.defaultStatus || savedSettings.defaultStatus}
        handleChange={(value): void => onChange({ defaultStatus: value })}
        className={classes.fullWidth}
      />
      <PlexSelect
        label={'Time Zone'}
        options={TimeZoneEnumData}
        value={unsavedSettings.timeZone || savedSettings.timeZone}
        handleChange={(value): void => onChange({ timeZone: value })}
        className={classes.borderRight}
      />
      <PlexSelect
        label={'Language'}
        options={LanguageEnumData}
        value={unsavedSettings.language || savedSettings.language}
        handleChange={(value): void => onChange({ language: value as LanguageEnum })}
        className={classes.halfWidth}
      />
    </SettingsContent>
  );
};
